// Клиент `GET /api/v1/me/permissions` — собственные права принципала в
// его активной организации.
//
// Типы вшиты руками параллельно с backend Pydantic-схемой
// (`backend/core/rbac/schemas.py`). Набор — подсказка интерфейсу, а не
// авторизация: право на действие проверяет ручка действия (ADR-0080).

import { authedFetch } from "../../auth/authedFetch";

export interface OwnPermissionsResponse {
  /** Организация, для которой посчитан набор; `null` — org-less сессия. */
  readonly org_id: string | null;
  /** Коды org-scope прав по возрастанию; пусто без организации/членства. */
  readonly permissions: readonly string[];
}

export async function fetchOwnPermissions(): Promise<OwnPermissionsResponse> {
  const response = await authedFetch("/api/v1/me/permissions", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`permissions: HTTP ${String(response.status)}`);
  }
  return (await response.json()) as OwnPermissionsResponse;
}
